import { ShieldOff } from "lucide-react";
import React from "react";
import { cn } from "../../lib/utils";

interface PermissionDeniedProps {
  message?: string;
  className?: string;
}

const PermissionDenied: React.FC<PermissionDeniedProps> = ({
  message = "You don't have permission to view this data. Contact your administrator if you think this is a mistake.",
  className,
}) => (
  <div
    role="alert"
    className={cn(
      "flex flex-col items-center justify-center gap-2 px-6 py-12 text-center",
      className
    )}
  >
    <ShieldOff className="h-8 w-8 text-pColor" />
    <p className="font-semibold text-hColor">Access denied</p>
    <p className="max-w-md text-sm text-pColor">{message}</p>
  </div>
);

export default PermissionDenied;
